














import Vue from 'vue';

export default Vue.extend({
    name: 'Custom',
    components: {
        
    },
    data() {
        return {
            
        }
    },
    mounted() {
        (window as any).hbspt.forms.create({
            portalId: "249181",
            formId: "653a62ea-e1b3-462c-971b-c182bd2587a9",
            target: '#contact-form'
        });
        setTimeout(() => {
            this.$store.state.routeLoaded = true;
            
        }, 800);
    },
    methods: {

    }
})
